import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { showToast } from '../../Toast/CommonToast';

function ChannelSuccess() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith('/socialmedia/success')) {
      const navigateLocation = localStorage.getItem('youtubeLocation');
      if (id) {
        showToast(`Channel has been successfully connected!`, 'success');
      } else {
        showToast('Please create a channel first then try to connect it with YouTube.', 'success');
      }
      const timer = setTimeout(() => {
        navigate(navigateLocation ? navigateLocation : '/home', { state: { popup: true } });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [location, navigate, id]);

  return (
    <Box>
      {id ? (
        <Typography variant="h6" sx={{ textAlign: 'center', mt: 2, }}>
          Channel {id} has been successfully created!
        </Typography>
      ) : (
        <Typography variant="h6" sx={{ textAlign: 'center', mt: 2 }}>
          Please create a channel first then try to connect it with youtube.
        </Typography>
      )}
    </Box>
  );
}

export default ChannelSuccess;
